var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3636 8.37902V3.62103L10.5455 6.00009L6.3636 8.37902ZM15.6656 2.12389C15.4816 1.43103 14.9394 0.885374 14.2511 0.700192C13.0033 0.363647 7.99997 0.363647 7.99997 0.363647C7.99997 0.363647 2.99665 0.363647 1.74893 0.700192C1.06057 0.885374 0.518386 1.43103 0.334363 2.12389C0 3.37973 0 6.00003 0 6.00003C0 6.00003 0 8.62018 0.334363 9.87609C0.518386 10.569 1.0605 11.1146 1.74893 11.2999C2.99665 11.6363 7.99997 11.6363 7.99997 11.6363C7.99997 11.6363 13.0033 11.6363 14.2511 11.2999C14.9394 11.1146 15.4816 10.569 15.6656 9.87609C16 8.62018 16 5.99996 16 5.99996C16 5.99996 16 3.37973 15.6656 2.12389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social_youtube.d786461dcc0de05c92308aa08065f3c6.svg";
export { ForwardRef as ReactComponent };